import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  parse(value: string): NgbDateStruct | null {
    if (!value) return null;

    const parts = value.trim().split(/[-/.]/);
    if (parts.length !== 3) return null;

    return {
      year: +parts[0],
      month: +parts[1],
      day: +parts[2]
    };
  }

  format(date: NgbDateStruct | null): string {
    if (!date) return '';
    return `${date.year}-${this.pad(date.month)}-${this.pad(date.day)}`;
  }

  private pad(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }
}
